/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Provision_Edit_TitleInputs */

const cs_deal_provision_edit_title = /** @type {(inputs: Deal_Provision_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provize obchodu`)
};

const en_deal_provision_edit_title = /** @type {(inputs: Deal_Provision_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal commission`)
};

/**
* | output |
* | --- |
* | "Deal commission" |
*
* @param {Deal_Provision_Edit_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_edit_title = /** @type {((inputs?: Deal_Provision_Edit_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_Edit_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_edit_title(inputs)
	return cs_deal_provision_edit_title(inputs)
});